import {BrowserModule} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule, inject } from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {provideTranslateService, TranslatePipe} from '@ngx-translate/core';
import {
    provideNgxWebstorage,
    withLocalStorage,
    withNgxWebstorageConfig,
    withSessionStorage
} from 'ngx-webstorage';
import {CommonModule, DatePipe} from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {AutosizeModule} from 'ngx-autosize';
import {TrackingModule} from '../services/tracking/tracking.module';
import {NgxFileDropModule} from 'ngx-file-drop';

import {
    ApiService,
    LoadingSpinnerService,
    ToastService,
    ProjectService,
    TranslationService,
    UserService,
    NgSelectService,
    DocumentService
} from '../services';

import {TRANSLATION_NL} from '../translations';

import {
    PageLogoutComponent,
    PageNoAccessComponent,
    PageErrorComponent,
    PageProjectsComponent,
    PageProjectDetailsComponent
} from '../pages/';

import {AppComponent} from './app.component';

import {
    LoadingSpinnerComponent,
    ProjectDetailsComponent,
    ScrollNavigationComponent,
    MenuComponent,
    NavItemComponent,
    ProjectStatusComponent,
    DocumentsComponent
} from '../components';

import {
    DateFormatPipe,
    NamesFormatPipe,
    EuroFormatPipe,
    CountryNamePipe,
    TenderCostsRangePipe,
} from '../pipes';

import {environment} from '../environments/environment';
import {VwuiAngularModule} from '@bvgo-ict/vwui-angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {ToastrModule} from 'ngx-toastr';
import {FormatEuroCentsDirective} from '../directives/format-euro-cents.directive';
import {VwuiTableDefaultBreakpointDirective} from '../directives/vwui-table-default-breakpoint.directive';
import {MsAuthModule} from '../module/ms-auth';
import {UiAccessibilityModule} from '../module/ui-accessibility';

@NgModule({
    declarations: [
        FormatEuroCentsDirective,
        VwuiTableDefaultBreakpointDirective,
        AppComponent,
        ProjectDetailsComponent,
        ScrollNavigationComponent,
        PageNoAccessComponent,
        PageErrorComponent,
        PageProjectDetailsComponent,
        PageProjectsComponent,
        PageLogoutComponent,
        LoadingSpinnerComponent,
        DateFormatPipe,
        MenuComponent,
        NavItemComponent,
        EuroFormatPipe,
        NamesFormatPipe,
        CountryNamePipe,
        TenderCostsRangePipe,
        ProjectStatusComponent,
        DocumentsComponent
    ],
    imports: [
        BrowserModule,
        MsAuthModule.forRoot(environment.msAuth),
        AppRoutingModule,
        ToastrModule.forRoot(),
        VwuiAngularModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        AutosizeModule,
        TrackingModule,
        NgxFileDropModule,
        CommonModule,
        UiAccessibilityModule.forRoot(),
        TranslatePipe
    ],
    providers: [
        ApiService,
        DatePipe,
        LoadingSpinnerService,
        NgSelectService,
        ProjectService,
        DocumentService,
        provideNgxWebstorage(
            withNgxWebstorageConfig({ prefix: 'PIT', separator: '_', caseSensitive: true }),
            withLocalStorage(),
            withSessionStorage()
        ),
        ToastService,
        provideTranslateService(),
        UserService,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ],
    bootstrap: [
        AppComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
    private translationService = inject(TranslationService);
    private ngSelectService = inject(NgSelectService);
    public static injector: Injector;

    constructor() {
        const injector = inject(Injector);
        const translationService = this.translationService;
        const ngSelectService = this.ngSelectService;

        AppModule.injector = injector;

        translationService.add({
            nl: TRANSLATION_NL
        });
        translationService.set('nl');
        translationService.addCountries();
        ngSelectService.init();
    }

}
